import get from "lodash/get";

/**
 * A utility that returns a sort comparator that compares on the
 * given property.
 *
 * @param {String} propPath - the dotted object property path.
 * @param {('asc'|'desc')} direction - the sort direction.
 * @param {Object} a - First object to compare
 * @param {Object} b - Second object to compare.
 *
 * @return {number} - Returns an ordinal representing the rank of the sort.
 */
function sortByProp(propPath, direction, a, b) {
  const multiplier = direction === "asc" ? 1 : -1;
  const aVal = get(a, propPath);
  const bVal = get(b, propPath);

  if (aVal < bVal) {
    return multiplier * -1;
  }

  if (aVal > bVal) {
    return multiplier;
  }

  return 0;
}

const sortByDisplayNameAsc = sortByProp.bind(null, "display_name", "asc");
const sortByKeyAsc = sortByProp.bind(null, "k", "asc");
const sortByLabelAsc = sortByProp.bind(null, "label", "asc");
const sortByNameAsc = sortByProp.bind(null, "name", "asc");
const sortByValueAsc = sortByProp.bind(null, "value", "asc");

const sortNumericAsc = (a, b) => a - b;
const sortNumericDesc = (a, b) => b - a;

export {
  sortByDisplayNameAsc,
  sortByKeyAsc,
  sortByLabelAsc,
  sortByNameAsc,
  sortByProp,
  sortByValueAsc,
  sortNumericAsc,
  sortNumericDesc,
};
